var map = {
	"./add_book_cover.svg": "76d2",
	"./avatar-image-big.jpg": "6a65",
	"./barcode-pic-example.jpg": "e06f",
	"./bf-add.svg": "23e3",
	"./bf-plus.svg": "3f36",
	"./bg/articleBottomOverlay — kopia.png": "1463",
	"./bg/articleBottomOverlay.gif": "d4f8",
	"./bg/articleBottomOverlay.png": "1a51",
	"./bg/bg1.jpg": "ef8e",
	"./book_scan.png": "646d",
	"./bottom_menu_icons/barcode.svg": "28c4",
	"./bottom_menu_icons/home.svg": "1d9a",
	"./bottom_menu_icons/loupe.svg": "9405",
	"./bottom_menu_icons/message.svg": "f228",
	"./bottom_menu_icons/scan.svg": "c7aa",
	"./bottom_menu_icons/search.svg": "492e",
	"./bottom_menu_icons/training.svg": "39a0",
	"./cover-1.jpg": "9b2d",
	"./desktop/avatar-placeholder.jpg": "b617",
	"./desktop/bg-login.jpg": "0c75",
	"./desktop/bookme-logo-white.png": "ab79",
	"./desktop/profile-picture-avatar.jpg": "02cd",
	"./desktop/profile-picture-big.jpg": "9a72",
	"./desktop/shape-bg-login.svg": "b986",
	"./desktop/shape-book-no-cover.svg": "1e5e",
	"./download-icon.svg": "ebb7",
	"./feed/create_reading_plan.png": "5bc8",
	"./feed/create_your_library.png": "7d39",
	"./feed/feed_check.svg": "90b6",
	"./feed/feed_reload.svg": "fa2f",
	"./feed/feedback.svg": "f812",
	"./feed/filter.svg": "0bc2",
	"./feed/heart.svg": "e63c",
	"./feed/heart_full.svg": "7f71",
	"./feed/intro_hand.png": "8bb0",
	"./feed/intro_hand_white_left.png": "6bd7",
	"./feed/intro_hand_white_up.png": "703f",
	"./feed/messages.svg": "88f4",
	"./feed/pencil.svg": "594a",
	"./feed/rating.svg": "e041",
	"./feed/send.svg": "fc0c3",
	"./feed/shape_arrows_reverse.png": "ea97",
	"./feed/shape_green.png": "d983",
	"./feed/shape_orange.png": "0643",
	"./feed/shape_red_arrows.png": "a407",
	"./feed/shape_yellow.png": "80a2",
	"./feed/share_books.png": "60c0",
	"./feed/top.svg": "2312",
	"./feed/write_first_review.png": "6f6c",
	"./genres/1.png": "019d",
	"./genres/2.png": "9117",
	"./genres/3.png": "ba8a",
	"./icon.png": "f8a2",
	"./no_cover.png": "e9b3",
	"./ph-face.png": "bf3d",
	"./plans/book_plan.svg": "387b",
	"./plans/page_plan.svg": "2c0a",
	"./plans/time_plan.svg": "7620",
	"./poziom1.svg": "a6d1",
	"./poziom10.svg": "743d",
	"./poziom11.svg": "075c",
	"./poziom12.svg": "6301",
	"./poziom2.svg": "b627",
	"./poziom3.svg": "6e62",
	"./poziom4.svg": "d6196",
	"./poziom5.svg": "9d06",
	"./poziom6.svg": "7c72",
	"./poziom7.svg": "f0f8",
	"./poziom8.svg": "1888",
	"./poziom9.svg": "bdfb",
	"./profile-avatar-circle-full.jpg": "dc1a",
	"./profile-book-cover.jpg": "d495",
	"./profile-pic.jpg": "6e2a",
	"./profile.jpg": "4b94",
	"./quotemark.png": "99f65",
	"./send-icon.svg": "cd5a",
	"./side_menu_icons/facebook.svg": "b29a",
	"./side_menu_icons/gear.svg": "49ab",
	"./side_menu_icons/globe.svg": "67cb",
	"./side_menu_icons/help.svg": "5d26",
	"./side_menu_icons/instagram.svg": "1340",
	"./side_menu_icons/library.svg": "8369",
	"./side_menu_icons/messages.svg": "5237",
	"./side_menu_icons/plans.svg": "5adf",
	"./side_menu_icons/star.svg": "e063",
	"./sights.png": "82c3",
	"./top-temp.png": "3c0b",
	"./topic-cover.jpg": "2cf42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";